import {
    CREATE_GENERAL_PO_DETAILS_REQUEST,
    CREATE_GENERAL_PO_DETAILS_SUCCESS,
    CREATE_GENERAL_PO_DETAILS_FAILURE,
    DELETE_GENERAL_PO_DETAILS_REQUEST,
    DELETE_GENERAL_PO_DETAILS_SUCCESS,
    DELETE_GENERAL_PO_DETAILS_FAILURE,
    FETCH_SINGLE_GENERAL_PO_DETAILS_REQUEST,
    FETCH_SINGLE_GENERAL_PO_DETAILS_SUCCESS,
    FETCH_SINGLE_GENERAL_PO_DETAILS_FAILURE,
    FETCH_GENERAL_PO_DETAILS_REQUEST,
    FETCH_GENERAL_PO_DETAILS_SUCCESS,
    FETCH_GENERAL_PO_DETAILS_FAILURE,
    UPDATE_GENERAL_PO_DETAILS_REQUEST,
    UPDATE_GENERAL_PO_DETAILS_SUCCESS,
    UPDATE_GENERAL_PO_DETAILS_FAILURE,
    RESET_GENERAL_PO_DETAILS_INFO,
    RESET_GENERAL_PO_DETAILS_ADD_NEW,
    CREATE_GENERAL_PO_DETAILS_FORM,
    UPDATE_GENERAL_PO_DETAILS_FORM,
    FETCH_GENERAL_PO_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_GENERAL_PO_DETAILS_APPROVAL_STATUS_REQUEST,
    FETCH_GENERAL_PO_DETAILS_APPROVAL_STATUS_SUCCESS,
    FETCH_GENERAL_PO_DETAILS_APPROVAL_STATUS_FAILURE,
    FETCH_GENERAL_PO_DETAILS_SUCCESS_GET,
} from './generalPoDetails.actionsType';

export const GENERAL_PO_DETAILS = 'generalPoDetails';

let initialState = {
    loading: false,
    generalPoDetails: [],
    generalDcdetails: [],
    generalPoDetailsWithoutId: [],
    generalPoDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let generalPoDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_GENERAL_PO_DETAILS_REQUEST:
        case CREATE_GENERAL_PO_DETAILS_REQUEST:
        case UPDATE_GENERAL_PO_DETAILS_REQUEST:
        case FETCH_SINGLE_GENERAL_PO_DETAILS_REQUEST:
        case DELETE_GENERAL_PO_DETAILS_REQUEST:
        case FETCH_GENERAL_PO_DETAILS_APPROVAL_STATUS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_GENERAL_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetails: updatePayload
            };
        case FETCH_GENERAL_PO_DETAILS_APPROVAL_STATUS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_GENERAL_PO_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsWithoutId: updatePayload
            };
        case FETCH_GENERAL_PO_DETAILS_SUCCESS_GET:
            return {
                ...state,
                loading: false,
                generalDcdetails: updatePayload
            }
        case CREATE_GENERAL_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                     fldFKHSNCode: null,
                    fldHSNCode: '',
                   fldFKColour: null,
                   fldFKSize: null,
            fldSize: '',

            fldFKUOM: null
                }
            };
        case UPDATE_GENERAL_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_GENERAL_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: updatePayload
            };
        case DELETE_GENERAL_PO_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_GENERAL_PO_DETAILS_ADD_NEW:
    return {
        ...state,
        generalPoDetailsForm: {
            ...state.generalPoDetailsForm,

            fldFKHSNCode: null,
            fldHSNCode: '',

            fldFKColour: null,

            fldFKSize: null,
            fldSize: '',

            fldFKUOM: null
        }
    };
        case RESET_GENERAL_PO_DETAILS_INFO:
            return {
                ...state,
                generalPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKGeneralHeader: 0,
                    fldFKGeneralItem: 0,
                    fldItemDescription: '',
                    fldFKHSNCode: null,
                    fldHSNCode: '',
                   fldFKColour: null,
                   fldFKSize: null,
            fldSize: '',

            fldFKUOM: null
                }
            };
        case CREATE_GENERAL_PO_DETAILS_FORM:
        case UPDATE_GENERAL_PO_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                generalPoDetailsForm: {
                    ...state.generalPoDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_GENERAL_PO_DETAILS_FAILURE:
        case CREATE_GENERAL_PO_DETAILS_FAILURE:
        case UPDATE_GENERAL_PO_DETAILS_FAILURE:
        case FETCH_SINGLE_GENERAL_PO_DETAILS_FAILURE:
        case DELETE_GENERAL_PO_DETAILS_FAILURE:
        case FETCH_GENERAL_PO_DETAILS_APPROVAL_STATUS_FAILURE:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
};
